import managementForm from './management-form'
import managementUi from './management-ui'

export default {
    managementForm,
    managementUi
}
